// フロントで表示するエラーメッセージ
export const ReactError = {
	E0001: 'このフィールドは入力必須です。',
	E0002: 'ログイン失敗が何度も施行されました。 しばらくたってからログインしてください。',
	E0003: 'GakkenIDかパスワードが一致しませんでした。',
	E0004: 'メールアドレスが正しくありません。',
	E0005: '既に登録されているIDです。',
	E0006: '半角や特殊な記号は使用せず、100文字以内で入力してください。',
	E0007: '100文字以内で特殊な記号は入力しないでください。',
	E0008: 'ログイン画面情報を取得できませんでした。',
	E0009: 'カード情報の削除に失敗しました。もう一度お試しください。',
	E0010: '一定回数失敗したため、ワンタイムパスワードが無効になりました。再度手続きを行ってください。',
	E0011: '4000文字以内で入力してください。',
	E0012: 'カードの上限に達しています。',
	E0013: '選択されたお支払い方法で決済できませんでした。再度お試しいただくか、別のお支払い方法を選択してください。',
	E0014: '選択されたお支払い方法は利用できませんでした。再度お試しいただくか、別のお支払い方法を選択してください。',
	E0015: '入力されたカードは利用できませんでした。再度お試しいただくか、別のカードを入力してください。',
	E9998: 'リクエストタイムアウトによりデータの取得ができませんでした。',
	E9999: 'サーバー側でエラーが発生しました。',
};
